import styles from './style.module.css';

export default function FullPageLoader() {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.ldsRing}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
